import { graphql, StaticQuery, Link } from 'gatsby';
import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import SliderSettings from '../Slider/SliderSettings';

const PromotedCategory = (props) => {
  const data = props.allTaxonomyTermProductCategories;
  let slidesToShowD = 4, 
    slidesToShowT = 2.2, 
    slidesToShowM = 1.05,
    sliderDetails = {},
    slidelist = [];
  slidelist = data.nodes.map((node) => (
    <div className="w-2.4/10 relative category-card" key={node.id}>
      {(() => {
        if (node?.relationships?.field_image?.localFile) {
          return (
            <GatsbyImage
              image={node?.relationships?.field_image?.localFile?.childImageSharp?.gatsbyImageData} 
              alt={node?.relationships?.field_image?.filename}
            />
          );
        }
      })()}
      <div className="-mt-23 text-center block w-full mx-auto">
        {(() => {
          if (node.relationships.parent[0]) {
            return (
              <Link className="button-black relative w-72" to={node.path.alias}>
                {node.name}
              </Link>
            );
          }
          return (
            <Link className="button-black relative w-72" to={node.path.alias}>
              {node.name}
            </Link>
          );
        })()}
      </div>
    </div>
  ));
  sliderDetails = {
    slidelist:slidelist,
    slidesToShow:slidesToShowD > slidelist.length ? slidelist.length : slidesToShowD,
    slidesToShowTab:slidesToShowT > slidelist.length ? slidelist.length : slidesToShowT,
    slidesToShowMobile:slidesToShowM > slidelist.length ? slidelist.length : slidesToShowM,
    centerMode:true
  }
  return (
    <div className="section promoted-category">
      <h3 className="section-title">
        Shop The Area By
        <span className="block">Category -</span>
      </h3>
      <div>
        <SliderSettings {...sliderDetails} />
      </div>
    </div>
  );
};
export default (props) => (
  <StaticQuery
    query={graphql`query PromotedCategoryQuery {
  allTaxonomyTermProductCategories(
    sort: {order: DESC, fields: changed}
    limit: 4
    filter: {field_featured: {eq: true}}
  ) {
    nodes {
      name
      id
      path {
        alias
      }
      relationships {
        parent {
          name
        }
        field_image {
          filename
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 500
                height: 704
                breakpoints: [400, 768]
                transformOptions: {cropFocus: CENTER}
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  }
}
`}
    render={(data) => (
      <PromotedCategory {...data} />
    )}
  />
);
